import React, {useState, useEffect} from "react";
import App from "./App";
import Simple from "./Simple";
import "./Main.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function Main() {
    const [isDarkMode, setIsDarkMode] = useState(false); // Light/Dark Mode

    const toggleTheme = () => {
        const newTheme = !isDarkMode;
        setIsDarkMode(newTheme);
    
        if (newTheme) {
          document.getElementById("main-container").style.setProperty("--terminal-color", "0, 0, 0");
          document.getElementById("main-container").style.setProperty("--text-color", "0, 255, 0");
          document.getElementById("main-container").style.setProperty("--background-color", "30, 30, 30");
          document.getElementById("main-container").style.setProperty("--link-color", "255, 100, 100");
        } else {
          document.getElementById("main-container").style.setProperty("--terminal-color", "255, 255, 255");
          document.getElementById("main-container").style.setProperty("--text-color", "0, 0, 0");
          document.getElementById("main-container").style.setProperty("--background-color", "225, 225, 225");
          document.getElementById("main-container").style.setProperty("--link-color", "100, 100, 255");
        }
      };

    // Apply theme once on load
    useEffect(() => {
      if (isDarkMode) {
        document.getElementById("main-container").style.setProperty("--terminal-color", "0, 0, 0");
        document.getElementById("main-container").style.setProperty("--text-color", "0, 255, 0");
        document.getElementById("main-container").style.setProperty("--background-color", "30, 30, 30");
        document.getElementById("main-container").style.setProperty("--link-color", "255, 100, 100");
      } else {
        document.getElementById("main-container").style.setProperty("--terminal-color", "255, 255, 255");
        document.getElementById("main-container").style.setProperty("--text-color", "0, 0, 0");
        document.getElementById("main-container").style.setProperty("--background-color", "225, 225, 225");
        document.getElementById("main-container").style.setProperty("--link-color", "100, 100, 255");
      }
    }, []);

    return (
        <div id="main-container">
        <Router>
            <Routes>
                <Route path="/" element={<App id="aboutlink"/>} />
                <Route path="/simple" element={<Simple />} />
            </Routes>
        </Router>
        <div className="theme-switch">
        <label className="switch">
          <input type="checkbox" checked={isDarkMode} onChange={toggleTheme} />
          <span className="slider">
          </span>
        </label>
      </div>
        </div>
    );
}

export default Main;